import { PageId } from 'constants/pages'

export const enum PageIdIntl2 {
  ANALYZING = PageId.ANALYZING_INTL_2,
  START = PageId.START_INTL_2,
  QUESTION_1 = PageId.QUESTION_1_INTL_2,
  QUESTION_2 = PageId.QUESTION_2_INTL_2,
  QUESTION_3 = PageId.QUESTION_3_INTL_2,
  QUESTION_4 = PageId.QUESTION_4_INTL_2,
  SPEED_FEEDBACK = PageId.SPEED_FEEDBACK_INTL_2,
  QUESTION_5 = PageId.QUESTION_5_INTL_2,
  QUESTION_6 = PageId.QUESTION_6_INTL_2,
  QUESTION_7 = PageId.QUESTION_7_INTL_2,
  QUESTION_8 = PageId.QUESTION_8_INTL_2,
  QUESTION_9 = PageId.QUESTION_9_INTL_2,
  QUESTION_10 = PageId.QUESTION_10_INTL_2,
  QUESTION_11 = PageId.QUESTION_11_INTL_2,
  QUESTION_12 = PageId.QUESTION_12_INTL_2,
  SMARTNESS_FEEDBACK = PageId.SMARTNESS_FEEDBACK_INTL_2,
  QUESTION_13 = PageId.QUESTION_13_INTL_2,
  QUESTION_14 = PageId.QUESTION_14_INTL_2,
  QUESTION_15 = PageId.QUESTION_15_INTL_2,
  QUESTION_16 = PageId.QUESTION_16_INTL_2,
  QUESTION_17 = PageId.QUESTION_17_INTL_2,
  QUESTION_18 = PageId.QUESTION_18_INTL_2,
  QUESTION_19 = PageId.QUESTION_19_INTL_2,
  QUESTION_20 = PageId.QUESTION_20_INTL_2,
  LOGICAL_SKILLS_FEEDBACK = PageId.LOGICAL_SKILLS_FEEDBACK_INTL_2,
  QUESTION_21 = PageId.QUESTION_21_INTL_2,
  QUESTION_22 = PageId.QUESTION_22_INTL_2,
  QUESTION_23 = PageId.QUESTION_23_INTL_2,
  QUESTION_24 = PageId.QUESTION_24_INTL_2,
  QUESTION_25 = PageId.QUESTION_25_INTL_2,
  AGE_QUESTION = PageId.AGE_QUESTION_INTL_2,
  EDUCATION_QUESTION = PageId.EDUCATION_QUESTION_INTL_2,
  DISCOVER_FEEDBACKS = PageId.DISCOVER_FEEDBACKS_INTL_2,
  PREPARE_FLOW = PageId.PREPARE_FLOW_INTL_2,
  EMAIL = PageId.EMAIL_INTL_2,
  EMAIL_CONSENT = PageId.EMAIL_CONSENT_INTL_2,
  OFFER = PageId.OFFER_INTL_2,
  SPECIAL_DISCOUNT = PageId.SPECIAL_DISCOUNT_INTL_2,
  CANCEL_OFFER = PageId.CANCEL_OFFER_INTL_2,
  PAYMENT = PageId.PAYMENT_INTL_2,
  CHECKOUT = PageId.CHECKOUT_INTL_2,
  UPSELL = PageId.UPSELL_INTL_2,
  REGISTRATION = PageId.REGISTRATION_INTL_2,
  NAME_ENTRY = PageId.NAME_ENTRY_INTL_2,
  CERTIFICATE = PageId.CERTIFICATE_INTL_2,
  REPORT = PageId.REPORT_INTL_2,
}

export const WHITE_BG_PAGE_IDS: string[] = [
  PageIdIntl2.SPEED_FEEDBACK,
  PageIdIntl2.SMARTNESS_FEEDBACK,
  PageIdIntl2.LOGICAL_SKILLS_FEEDBACK,
  PageIdIntl2.EMAIL_CONSENT,
  PageIdIntl2.SPECIAL_DISCOUNT,
  PageIdIntl2.REGISTRATION,
]
